import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-title d-flex align-items-center flex-wrap me-3 mb-md-5 mb-lg-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "d-none d-lg-flex d-flex align-items-center text-dark fw-bolder fs-3 my-1" }, "Profile & Settings", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-flex h-20px border-gray-200 border-start mx-4" }, null, -1)
const _hoisted_4 = { class: "d-md-none d-flex overflow-auto justify-content-center" }
const _hoisted_5 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-chevron-double-left fs-1" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-user-cog fa-2x" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "nav-item" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-calendar-times fa-2x" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "nav-item" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-address-book fa-2x" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("ul", _hoisted_5, [
        _createElementVNode("li", _hoisted_6, [
          _createElementVNode("a", {
            class: "nav-link text-active-white me-6",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.returnHome && _ctx.returnHome(...args)))
          }, _hoisted_8)
        ]),
        _createElementVNode("li", _hoisted_9, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link text-active-white me-6", {'active': _ctx.currentRoute === 'user-settings-general'}]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigate('user-settings-general')))
          }, _hoisted_11, 2)
        ]),
        _createElementVNode("li", _hoisted_12, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link text-active-white me-6", {'active': _ctx.currentRoute === 'user-settings-conflicts'}]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigate('user-settings-conflicts')))
          }, _hoisted_14, 2)
        ]),
        _createElementVNode("li", _hoisted_15, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link text-active-white me-6", {'active': _ctx.currentRoute === 'user-settings-emergency-contacts'}]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigate('user-settings-emergency-contacts')))
          }, _hoisted_17, 2)
        ])
      ])
    ])
  ]))
}